
import {timer as observableTimer,  Observable } from 'rxjs';

import {tap, map, take} from 'rxjs/operators';
import { Component, Output, EventEmitter } from '@angular/core';





@Component({
    selector: 'app-countdown',
    templateUrl: './countdown.component.html',
    styleUrls: ['./countdown.component.scss']
})
export class CountdownComponent {
    public displayValue!: Observable<string>;

    @Output()
    public completed = new EventEmitter<any>();

    public countdownTo(targetTime: Date): void {
        let seconds = getRemainingSeconds(targetTime);
        this.displayValue =
            observableTimer(0, 1000).pipe(
                take(seconds + 1),
                map(x => Math.floor(seconds - x)),
                tap(x => this.fireCompletedIfDone(x)),
                map(getDisplayValue),);
    }

    private fireCompletedIfDone(remainingSeconds: number): void {
        if (remainingSeconds <= 0) {
            this.completed.emit();
        }
    }
}

function getRemainingSeconds(targetTime: Date): number {
    if (!(targetTime instanceof Date)) {
        targetTime = new Date(targetTime);
    }
    return Math.floor(Math.max(0, targetTime.getTime() - new Date().getTime())) / 1000;
}

function getDisplayValue(remainingSeconds: number): string {
    let minutes = Math.floor(remainingSeconds / 60);
    let seconds = remainingSeconds % 60;
    return padNumber(minutes) + ':' + padNumber(seconds);
};

function padNumber(n: number): string {
    let s = n.toString();
    while (s.length < 2) {
        s = '0' + s;
    }
    return s;
}